import { useTranslation } from 'react-i18next';

import CommonButton from '~atoms/CommonButton';
import * as WarningModalSt from '~molecules/WarningModal/WarningModal.styles';

type ZipNotServicedModalProps = {
  zipCode?: string;
  isVisible: boolean;
  onOk: () => void;
};

const ZipNotServicedModal = ({
  zipCode = '',
  isVisible,
  onOk,
}: ZipNotServicedModalProps) => {
  const { t } = useTranslation();

  return (
    <WarningModalSt.Container
      type="warning"
      title={t('EQUIVALENT_PRODUCT_MATCHING.ZIP_CODE.ALERT_TITLE')}
      content={t('EQUIVALENT_PRODUCT_MATCHING.ZIP_CODE.ALERT_TEXT', {
        zipCode,
      })}
      isVisible={isVisible}
      closable={false}
      keyboard={false}
      maskClosable={false}
      onClose={() => onOk()}
      footer={[
        <CommonButton key="ok" onClick={onOk} data-style="warning-primary">
          OK
        </CommonButton>,
      ]}
    />
  );
};

export default ZipNotServicedModal;
